module.exports = __webpack_public_path__ + "img/blog7.f0faf978.jpg";